import ContentShimmer from 'react-content-shimmer'
import { useGetShopTags } from '@framework/products/get-shop-tags'
import { uniqueArrayOnKey } from '@helper/globalHelpers'
import Scrollbar from '@components/ui/scrollbar'
import React from 'react'
import { firstBy } from 'thenby'
import secureLocalStorage from 'react-secure-storage'
import CategoryFilterMenu from './CategoryFilterMenu'
import { Box } from '@chakra-ui/react'

const CategoryFilters = ({
  shopId,
  display,
}: {
  display?: any
  shopId: string
  menu?: boolean
}) => {
  const { tags, isLoading, isError } = useGetShopTags(shopId)
  if (isError) return <Box py={{ base: '3', lg: '7' }}>Failed to load tags</Box>

  if (isLoading) {
    return (
      <ContentShimmer
        rows={6}
        style={{ margin: '.5em 0em' }}
        size={{ height: 40, width: '100%' }}
      />
    )
  }

  const tagsList = uniqueArrayOnKey(tags, 'slug')
    ?.filter((item: any) => item?.productCount > 0)
    .sort(firstBy('name'))

  // save to local storage
  if (tagsList?.length > 0) secureLocalStorage.setItem('tags', tagsList)

  const tagsListWithAll = [
    ...tagsList,
    {
      _id: 'ALL',
      type: 'system',
      name: 'All Categories',
      slug: 'all',
    },
  ]

  return (
    <Box
      as="aside"
      display={display ?? "block"}
      className={
        'lg:sticky lg:top-16 categoryItem-mobile-sidebar flex-shrink-0 pe-8 xl:pe-16'
      }
    >
      <div className="max-h-full overflow-hidden rounded border border-skin-base">
        <Scrollbar className="categoryItem-scrollbar w-full h-full">
          <CategoryFilterMenu items={tagsListWithAll} />
        </Scrollbar>
      </div>
    </Box>
  )
}

export default CategoryFilters
